// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { LucidePanelLeftClose as RawLucidePanelLeftClose } from "lucide-react";
export const LucidePanelLeftClose = /* @__PURE__ */ createIcon(RawLucidePanelLeftClose, "LucidePanelLeftClose", 2);
